module.exports = __webpack_public_path__ + "static/media/apex.f7edba44.svg";